import { Component, OnInit, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA, ViewChild } from '@angular/core';
import { StepsModule } from 'primeng/steps';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { PanelModule } from 'primeng/panel';
import { Message, SelectItem, ConfirmationService } from 'primeng/primeng';
import { NgxSpinnerService } from 'ngx-spinner';
import { StoreService } from '../store.service';
import { DialogModule } from 'primeng/dialog';


import { ApiService } from '../api.service';
import { SimplePdfViewerComponent, SimplePDFBookmark } from 'simple-pdf-viewer';
import { HttpHeaders, HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-doc-approve',
  templateUrl: './doc-approve.component.html',
  styleUrls: ['./doc-approve.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService]
})
export class DocApproveComponent implements OnInit {

  @ViewChild(SimplePdfViewerComponent) private pdfViewer: SimplePdfViewerComponent;
  bookmarks: SimplePDFBookmark[] = [];


  lstProduct: any = [];
  qboVendors: SelectItem[] = [];
  qboAccounts: SelectItem[] = [];
  loadingMessage: any = "Loading...";
  qboDocumentSelected: any; //Selected Qbo Document
  hdr: any = {
    VendorListID: '',
    AccountListID: '',
    ID: 0,
    ProductCode: '',
    VendorName: '',
    AccountName: ''

  }; //Selected Qbo Document
  hdrEdit: any = {
    VendorListID: '',
    AccountListID: '',
    ID: 0,
    ProductCode: '',
    VendorName: '',
    AccountName: ''

  };
  qboVendorsTemp: any = [];
  qboaccountsTemp: any = [];
  public msgs: Message[] = [];
  display: boolean = false;

  constructor(private router: Router, private api: ApiService, private ss: StoreService,
    private http: HttpClient, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.qboVendorsTemp = this.ss.fetchQboVendors();
    this.bindVendors();
    this.bindAccount();

  }

  bindVendors() {

    this.qboVendorsTemp = this.ss.fetchQboVendors();
    this.qboVendors.push({ label: '', value: '' });

    if (this.qboVendorsTemp == null) return;

    this.qboVendorsTemp.forEach(element => {
      this.qboVendors.push({ label: element.FullName, value: element.ListID });
    });
  }

  bindAccount() {
    this.qboaccountsTemp = this.ss.fetchQboAccount();
    this.qboAccounts.push({ label: '', value: '' });
    if (this.qboaccountsTemp == null) return;

    this.qboaccountsTemp.forEach(element => {
      this.qboAccounts.push({ label: element.FullName, value: element.ListID });
    });
  }

  onChangeVendor(event: any) {
    
    this.hdrEdit.AccountListID = '';
    this.hdrEdit.ProductCode = '';
    this.hdrEdit.VendorListID=event.value;
    console.log(this.hdrEdit.VendorListID);
    this.getProduct();
  }

  onChangeAccount(line: any, accountlst: any) {
    if (line) {
      line.QboAccountID = accountlst.QboAccountID;
      line.QboAccountName = accountlst.QboAccountName;
    }
  }


  getProduct() {

    console.log(this.hdr);
    this.spinner.show();
    this.loadingMessage = "Processing...";
    this.api.get('Rah/GetRahProduct?vendorListID=', this.hdrEdit.VendorListID).subscribe(
      (res: {}) => this.successGetproduct(res),
      error => this.failedApproveDoc(<any>error));

  }


  successGetproduct(resp: any) {
    this.msgs = [];
    this.spinner.hide();
    console.log(resp);
    this.lstProduct = resp.Data;
  }

  failedApproveDoc(resp: any) {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: 'Failed to get product', detail: 'Failed get product .' });
    this.spinner.hide();
  }

  save() {
    this.msgs = [];

    if (this.hdrEdit.VendorListID.length == 0 || this.hdrEdit.AccountListID.length == 0 || this.hdrEdit.ProductCode.length == 0) {
      this.msgs.push({ severity: 'error', summary: 'Please Fill all Required detail', detail: '' });

      return;
    }else{


     
        var lines1 = this.lstProduct.filter(xx => xx.ProductCode == this.hdrEdit.ProductCode.trim());
  
        if (lines1.length > 0) {
  
          this.msgs = [];
          this.msgs.push({ severity: 'error', summary: 'you have entered duplicate Product Code', detail: '' });
          this.spinner.hide();
          return;
        }
      

    
    if (this.hdr.ID === 0) {
      var lines = this.lstProduct.filter(xx => xx.ProductCode == this.hdrEdit.ProductCode.trim() && xx.AccountListID == this.hdrEdit.AccountListID);

      if (lines.length > 0) {

        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'you have entered duplicate Product Code and Expense Account', detail: '' });
        this.spinner.hide();
        return;
      }
    }


    console.log('lines');
    console.log(lines)

    this.loadingMessage = "Processing...";
    this.spinner.show();
    this.api.post('Rah/SaveRahProduct', this.hdrEdit).subscribe(
      (res: {}) => this.successSavetproduct(res),
      error => this.failedApproveDoc(<any>error));
    }
  }

  // save() {
  //   this.msgs = [];

  //   if (this.hdrEdit.VendorListID.length == 0 || this.hdrEdit.AccountListID.length == 0 || this.hdrEdit.ProductCode.length == 0) {
  //     this.msgs.push({ severity: 'error', summary: 'Please Fill all Required detail', detail: '' });

  //     return;
  //   }else{
    
  //   if (this.hdr.ID === 0) {
  //     var lines = this.lstProduct.filter(xx => xx.ProductCode == this.hdrEdit.ProductCode && xx.AccountListID == this.hdrEdit.AccountListID);

  //     if (lines.length > 0) {

  //       this.msgs = [];
  //       this.msgs.push({ severity: 'error', summary: 'you have entered duplicate Product Code and Expense Account', detail: '' });
  //       this.spinner.hide();
  //       return;
  //     }
  //   }


  //   console.log('lines');
  //   console.log(lines)

  //   this.loadingMessage = "Processing...";
  //   this.spinner.show();
  //   this.api.post('Rah/SaveRahProduct', this.hdrEdit).subscribe(
  //     (res: {}) => this.successSavetproduct(res),
  //     error => this.failedApproveDoc(<any>error));
  //   }
  // }

  reset(){
    this.hdrEdit.VendorListID="";
    this.hdrEdit.ProductCode="";
    this.hdrEdit.AccountListID=""
  }
  successSavetproduct(resp: any) {
    this.msgs = [];
    this.spinner.hide();
    console.log(resp);
    this.getProduct();
    this.hdrEdit.AccountListID = '';
    this.hdrEdit.ID = 0;
    this.hdrEdit.ProductCode = '';

  }

  edit(rowValue) {
    
    this.hdrEdit.AccountListID = rowValue.AccountListID;
    this.hdrEdit.ProductCode = rowValue.ProductCode;
    this.hdrEdit.VendorListID = rowValue.VendorListID;
    this.hdrEdit.ID=rowValue.ID;
  
  }

  delete(rowValue) {
    this.api.post('Rah/DeleteRahProduct', rowValue).subscribe(
      (res: {}) => this.successDeleteSalesItem(res),
      error => this.failedDeleteSalesItem(<any>error));
  }

  successDeleteSalesItem(resp: any) {
    this.msgs = [];
    this.spinner.hide();
    console.log(resp);
    this.getProduct();
    this.hdr.ItemListID = '';
    this.hdr.ProductCode = '';
  }

  failedDeleteSalesItem(resp: any) {
    this.msgs = [];
    this.msgs.push({ severity: 'Error', summary: 'Failed to delete mapped product', detail: 'somthing is wrong when try to delete item' });
    this.spinner.hide();
  }
}
